
<!--
File: catalog-delete.component.html
Project: catalog-cloud
File Created: Wednesday, 22nd December 2021 12:48:17
Author: Tomás Muniesa (tomas@cege.es)
-----
Last Modified:  Thursday, 17th October 2024 1:22:33 pm
Modified By: Tomás (tomas@cege.es>)
-----
Copyright 2021 - 2022 Nousmedis, CeGe
-->



<span class="list-delete-header"> {{ (this.idsCatalog.length > 1 ? 'CATALOG.DELETE_MANY' : 'CATALOG.DELETE_ONE') | translate }}</span>

<div class="list-delete-container">
  <span *ngFor="let item of catalogsName" class="list-delete-catalgos">
    {{item}}
  </span>
</div>


